import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import getParameters from '@app/libs/getParameters'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

export default function TransactionReport({ partners, total, partnerSearchList }) {
  const { t, i18n } = useTranslation()
  const { url } = usePage()
  const urlObj = new URL(url, location.origin)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'partner_name',
              Header: t('COST_REPORT.PARTNER'),
              accessor: 'partner_name',
              type: 'multiSelect',
              router: 'admin.report.cost',
              options: partnerSearchList,
              only: 'partnerSearchList',
            },
            {
              id: 'cost',
              Header: t('COST_REPORT.COST'),
              accessor: 'cost',
              type: 'number',
              align: 'center',
              autoHide: 'true',
              disableFilters: true,
            },
            {
              id: 'trans',
              Header: t('COST_REPORT.TRANSACTION'),
              accessor: 'update_at',
              type: 'dateRange',
              isVisible: false,
            },
          ]}
          data={partners}
          enableCollapseFilter={false}
          exportable={{
            enableExport: true,
            url: 'admin.report.cost.export',
            params: { ...getParameters(urlObj), locale: i18n.language },
          }}
          routeName="admin.report.cost"
          total={total}
        />
      </Grid>
    </Grid>
  )
}
